import React from 'react';
import styled from 'styled-components';
import { GhostButton } from '@ui/buttons';
import { Collapse } from '@assets/icons/svgs/Collapse';
import { Expand } from '@assets/icons/svgs/Expand';

const Group = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;

// Icon-sized and sitting with the row counter rather than up in the filter bar: density is a
// property of the grid you're looking at, so the control belongs against the grid.
const DensityButton = styled(GhostButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  /* Transparent rather than absent: it reserves the space the hover border fills. */
  border: 1px solid transparent;
  border-radius: 4px;
  opacity: ${({ $active }) => ($active ? 1 : 0.45)};

  &:hover {
    opacity: 1;
    border-color: ${({ theme }) => theme.themeColors.border};
  }

  &:focus-visible {
    outline-offset: 1px;
  }
`;

export const DensityToggle = ({ compact, onChange }) => (
  <Group role="group" aria-label="Row density">
    <DensityButton
      onClick={() => onChange(false)}
      $active={!compact}
      aria-pressed={!compact}
      aria-label="Comfortable rows"
      title="Comfortable rows"
    >
      <Expand size={14} />
    </DensityButton>
    <DensityButton
      onClick={() => onChange(true)}
      $active={compact}
      aria-pressed={compact}
      aria-label="Compact rows"
      title="Compact rows"
    >
      <Collapse size={14} />
    </DensityButton>
  </Group>
);
